export default __webpack_public_path__ + "static/media/posy.8b7b4c60.jpg";